var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`jj-toast type--${ _vm.type }`},[_c('font-awesome-icon',{staticClass:"icon",class:{ "fa-spin": ( _vm.type == `busy` ) },attrs:{"icon":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.content))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }